import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, AlertCircle, CheckCircle2, ArrowLeft } from 'lucide-react';
export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email) {
      setError('Please enter your email address.');
      return;
    }
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setIsSuccess(true);
    }, 1000);
  };
  return <div className="min-h-screen bg-slate-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 font-sans animate-in fade-in duration-500" data-id="element-538" data-mp="s2ym2g08pjyl">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-539" data-mp="2hixvzzbondfa">
        <div className="flex justify-center" data-id="element-540" data-mp="2mgzeoj575aq8">
          <div className="w-10 h-10 bg-slate-900 rounded-md" data-id="element-541" data-mp="2mfofyxqlyt5z"></div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-slate-900" data-id="element-542" data-mp="4tozuat96kom">
          Reset your password
        </h2>
        <p className="mt-2 text-center text-sm text-slate-600" data-id="element-543" data-mp="3w0hzvbcb8drk">
          Enter your email and we'll send you a reset link.
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-544" data-mp="9knivi5mlwvk">
        <div className="bg-white py-8 px-4 shadow-sm border border-slate-200 sm:rounded-xl sm:px-10" data-id="element-545" data-mp="9na0kam8dsri">
          {isSuccess ? <div className="text-center" data-id="element-546" data-mp="3d25r3qpb95wi">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-emerald-100 mb-4" data-id="element-547" data-mp="3d37aqjke70pu">
                <CheckCircle2 className="h-6 w-6 text-emerald-600" data-id="element-548" data-mp="3r3028h3qtkyv" />
              </div>
              <h3 className="text-lg font-medium text-slate-900 mb-2" data-id="element-549" data-mp="3myikengy1hqq">
                Check your inbox
              </h3>
              <p className="text-sm text-slate-600 mb-6" data-id="element-550" data-mp="16dane431hz66">
                We've sent password reset instructions to{' '}
                <strong data-id="element-551" data-mp="3v4l7o1o2mqxg">{email}</strong>.
              </p>
              <Link to="/login" className="w-full flex justify-center py-2.5 px-4 border border-slate-300 rounded-md shadow-sm text-sm font-medium text-slate-700 bg-white hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-900 transition-colors" data-id="element-552" data-mp="3v434el2zrcg1">
                Return to login
              </Link>
            </div> : <form className="space-y-6" onSubmit={handleSubmit} data-id="element-553" data-mp="3cbqu9c63j6vc">
              {error && <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-md text-sm flex items-start" data-id="element-554" data-mp="3haty4tacb71q">
                  <AlertCircle className="h-5 w-5 mr-2 shrink-0 mt-0.5" data-id="element-555" data-mp="3q4zx0tzjgu4w" />
                  <span data-id="element-556" data-mp="3q7cpw26u4owq">{error}</span>
                </div>}

              <div data-id="element-557" data-mp="2tmu8xxsofop9">
                <label htmlFor="email" className="block text-sm font-medium text-slate-700" data-id="element-558" data-mp="2tl9es9a9y7rx">
                  Email address
                </label>
                <div className="mt-1 relative rounded-md shadow-sm" data-id="element-559" data-mp="2q3bumkgqcsaj">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-560" data-mp="2l7msqah8mzb2">
                    <Mail className="h-4 w-4 text-slate-400" data-id="element-561" data-mp="2h36qcj6u2a0l" />
                  </div>
                  <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" placeholder="you@example.com" data-id="element-562" data-mp="2c4vek2wz9pfq" />
                </div>
              </div>

              <div data-id="element-563" data-mp="1jgpulidr04gy">
                <button type="submit" disabled={isLoading} className="w-full flex justify-center py-2.5 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-slate-900 hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-900 disabled:opacity-70 transition-colors" data-id="element-564" data-mp="1jian72gi5dc6">
                  {isLoading ? 'Sending...' : 'Send reset link'}
                </button>
              </div>

              <div className="text-center mt-4" data-id="element-565" data-mp="30rg1z0akmuye">
                <Link to="/login" className="inline-flex items-center text-sm font-medium text-slate-600 hover:text-slate-900" data-id="element-566" data-mp="34uujxwi2lleh">
                  <ArrowLeft className="h-4 w-4 mr-1" data-id="element-567" data-mp="2vtmywg4keh2c" />
                  Back to login
                </Link>
              </div>
            </form>}
        </div>
      </div>
    </div>;
}